import { PUBLIC_FILTER_TYPE } from '@/entities/public-filter/public-filter-constants';
import { Button } from '@/shared/components/shadcn/button';
import { PublicFilterItem } from './public-filter-item';
import { PublicFilterMenu, type PublicFilterValue } from './public-filter-menu';

type Props = {
  values: PublicFilterValue[];
  onChange: (value: PublicFilterValue[]) => void;
};

export function PublicFilter(props: Props) {
  const { values, onChange } = props;
  const keywordValue = values.find((value) => value.filterType === PUBLIC_FILTER_TYPE.KEYWORD);
  const filteredValues = values.filter((value) => value.filterType !== PUBLIC_FILTER_TYPE.KEYWORD);
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      {filteredValues.length > 0 && (
        <div className="flex flex-wrap gap-1 rounded-sm border p-1">
          {filteredValues.map((value) => (
            <PublicFilterItem
              key={`${value.filterType}-${value.value}`}
              {...value}
              onRemove={(value) => {
                const newValues = values.filter(
                  (v) => !(v.filterType === value.filterType && v.value === value.value),
                );

                onChange(newValues);
              }}
            />
          ))}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => (keywordValue ? onChange([{ ...keywordValue }]) : onChange([]))}
          >
            Clear
          </Button>
        </div>
      )}
      <PublicFilterMenu values={values} onChange={onChange} />
    </div>
  );
}
